import { forwardRef, HTMLAttributes } from 'react'
import { SkeletonBase } from './Skeleton.styles'

type SizeValue = number | string

const toCssSize = (value: SizeValue) =>
  typeof value === 'number' ? `${value}px` : value

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: SizeValue
  height?: SizeValue
  borderRadius?: SizeValue
}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  (
    {
      width = '100%',
      height = '16px',
      borderRadius = 8,
      style,
      ...restProps
    },
    ref
  ) => (
    <SkeletonBase
      ref={ref}
      style={{
        width: toCssSize(width),
        height: toCssSize(height),
        borderRadius: toCssSize(borderRadius),
        ...style
      }}
      {...restProps}
    />
  )
)

Skeleton.displayName = 'Skeleton'
